import { CurrencyDollarCircleIcon } from '@systemeio/icons';
import { BadRequest } from '@systemeio/util';
import { AffiliateCommissionInterface } from 'modules/funnels/funnel/components/step-configuration-tab/affiliate-commission/types/affiliate-commission-interface';
import { OfferConfigurationDisclosure } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-disclosure';
import { useEffect, useState } from 'react';
import { FormInputNumberGroup } from 'shared/components';
import { changedFromFetched, useActOnBlur } from 'shared/hooks/use-act-on-blur';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateCommissionProps extends AffiliateCommissionInterface {
  onSave: (data: AffiliateCommissionInterface) => Promise<void>;
}
const defaultValues: AffiliateCommissionInterface = {
  affiliateCommission: 0,
  payoutDelay: 0
};
function AffiliateCommission({
  affiliateCommission,
  payoutDelay,
  onSave
}: AffiliateCommissionProps) {
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState(defaultValues);
  const handleError = (error: Error) => {
    if (error instanceof BadRequest) {
      const errors = error.errors.fields;
      affiliateCommissionActor.setStatus(errors.affiliateCommission?.join(', '));
      payoutDelayActor.setStatus(errors.payoutDelay?.join(', '));
    }
  };
  const affiliateCommissionActor = useActOnBlur<AffiliateCommissionInterface['affiliateCommission']>(() => ({
    action: async value => {
      await onSave({
        ...tempState,
        affiliateCommission: value
      });
    },
    isValueChanged: changedFromFetched(affiliateCommission),
    onError: handleError
  }));
  const payoutDelayActor = useActOnBlur<AffiliateCommissionInterface['payoutDelay']>(() => ({
    action: async value_0 => {
      await onSave({
        ...tempState,
        payoutDelay: value_0
      });
    },
    isValueChanged: changedFromFetched(payoutDelay),
    onError: handleError
  }));
  useEffect(() => {
    setTempState({
      affiliateCommission,
      payoutDelay
    });
  }, [affiliateCommission, payoutDelay]);
  return <OfferConfigurationDisclosure defaultOpen icon={<CurrencyDollarCircleIcon />} title={t('dashboard.funnel.configuration.offer.affiliate_commission')} description={t('dashboard.funnel.configuration.offer.affiliate_commission-description')}>
      <div className="tablet:grid-cols-2 desktop:gap-3 grid gap-2">
        <FormInputNumberGroup label={t('dashboard.funnel.configuration.offer.affiliate_commission')} type="integer" onChange={value_1 => setTempState(prev => ({
        ...prev,
        affiliateCommission: value_1
      }))} suffix={!affiliateCommissionActor.isInProgress ? '%' : affiliateCommissionActor.statusIcon} onBlur={(_, processedNumber) => affiliateCommissionActor.handleBlur(processedNumber)} value={tempState.affiliateCommission} required max={100} error={affiliateCommissionActor.error} />
        <FormInputNumberGroup label={t('dashboard.funnel.configuration.offer.payout_delay')} type="integer" onChange={value_2 => setTempState(prev_0 => ({
        ...prev_0,
        payoutDelay: value_2
      }))} suffix={!payoutDelayActor.isInProgress ? (tempState.payoutDelay || 0) > 1 ? t('dashboard.transactions.sub_interval.days') : t('dashboard.transactions.sub_interval.day') : payoutDelayActor.statusIcon} onBlur={(__0, processedNumber_0) => payoutDelayActor.handleBlur(processedNumber_0)} max={100} value={tempState.payoutDelay} required error={payoutDelayActor.error} />
      </div>
    </OfferConfigurationDisclosure>;
}
export default AffiliateCommission;